import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { EntityTypeEnum } from '../../models/enums/entity-type.enum';
import { MutationFieldModel } from '../../models/mutation-field.model';
import { MutationModel } from '../../models/mutation.model';

@Injectable({
    providedIn: 'root'
})
export class MutationsResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'mutations' }));
    }

    /**
     * Returns list of mutations for the selected entity.
     * @param recordId Entity's ID.
     * @param type Entity's type.
     */
    get(recordId: string, type: EntityTypeEnum): Observable<ApiResponseModel<MutationModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<MutationModel[]>>(this.getUrl(`${type}/${recordId}`));
    }

    /**
     * Returns list of fields for the selected mutation.
     * @param mutationId Mutation's ID.
     */
    getFields(mutationId: string): Observable<ApiResponseModel<MutationFieldModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<MutationFieldModel[]>>(this.getUrl(`${mutationId}/fields`));
    }
}
